import {createStyles, Theme} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

export const usePatientActivityLogTableItemStyle = makeStyles((theme: Theme) => createStyles({
    noMargin: {
        margin: 0
    }
}));

export default usePatientActivityLogTableItemStyle;